import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomToneOfVoice,
  BackendMutationCreateCustomToneOfVoiceArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const MUTATION = gql`
  mutation CreateCustomToneOfVoice(
    $brandVoiceId: ID!
    $name: String!
    $description: String
    $defaultForGenerationTools: [GenerationToolEnum!]
    $traits: [Trait!]
    $personality: TovDefaultPresetEnum
  ) {
    createCustomToneOfVoice(
      brandVoiceId: $brandVoiceId
      name: $name
      description: $description
      defaultForGenerationTools: $defaultForGenerationTools
      traits: $traits
      personality: $personality
    ) {
      ...CustomToneOfVoice
    }
  }

  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

type Variables = BackendMutationCreateCustomToneOfVoiceArgs;
type Result = BackendCustomToneOfVoice;

export const createCustomToneOfVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
